module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    attrs: {
      "src": _vm.src,
      "width": "100%",
      "height": "100%"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-313a999d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tab.vue
// module id = 504
// module chunks = 1